import { render } from "./CustomCalendar.vue?vue&type=template&id=06f8ce9c&scoped=true"
import script from "./CustomCalendar.vue?vue&type=script&lang=js"
export * from "./CustomCalendar.vue?vue&type=script&lang=js"

import "./CustomCalendar.vue?vue&type=style&index=0&id=06f8ce9c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/double-daywrap-newsystem-php/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f8ce9c"]])

export default __exports__